import React from 'react';
import { Link } from 'react-router-dom';

const Shipments = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div className="header-container mb-3">
                    <div className="header"><h1>2 Відправки </h1></div>
                    <div className="header-functions">
                        <div className="float-end mx-2">
                            <Link className='btn btn-primary'>
                                Друк наклейок
                            </Link>
                        </div>
                    </div>
                </div>
                <a className="check_all" href="#">Виділити все</a>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th data-field="check"></th>
                            <th data-field="id">ТТН</th>
                            <th>Місто</th>
                            <th data-field="id">ID</th>
                            <th data-field="user_name" className="no-mobile">Товари</th>

                            <th data-field="user_date" className="no-mobile">Магазин</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="check_area text-right">
                                <div className="custom-control custom-checkbox">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                    <label className="custom-control-label" for="check_u178627">&nbsp;</label>
                                </div>
                            </td>
                            <td>
                                20450673071918
                                <div className="w_time">vobbi</div>
                                <div className="w_time"></div>
                            </td>
                            <td>Козин (Київська обл., Обухівський р-н)</td>
                            <td>
                                <a href="/order?id=178627" data-id="178627" className="mobile-select">Замовлення&nbsp;#178627</a>			                    	<div className="on-mobile">02.03.2023</div>
                                <div className="note note-note">Примітка: Продажа Yountel.UA</div>
                            </td>
                            <td className="no-mobile">
                                <ul className="list_purchaches">
                                    <li>
                                        <a href="/product?id=132744">Apple iPhone 6 16GB Space Gray Neverlock (61178)</a>
                                    </li>
                                    <li>
                                        <a href="/product?id=19734">Блок живлення для iPhone Комплектний </a>
                                    </li>
                                    <li>
                                        <a href="/product?id=108159">Кабель Lightning Комплектний </a>
                                    </li>
                                </ul>
                            </td>

                            <td>
                                <div className="product_store">Geeg</div>
                            </td>
                            <td className="text-right" style={{ padding: '0.5rem .75rem' }}>
                                <a href="print?orders=178627" target="_blank"><h3><i className="bi bi-printer"></i></h3></a>
                            </td>
                        </tr>
                        <tr>
                            <td className="check_area text-right">
                                <div className="custom-control custom-checkbox">
                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                    <label className="custom-control-label" for="check_u178623">&nbsp;</label>
                                </div>
                            </td>
                            <td>
                                20450673019847
                                <div className="w_time">Berest</div>
                                <div className="w_time"></div>
                            </td>
                            <td>Старі Маяки</td>
                            <td>
                                <a href="/order?id=178623" data-id="178623" className="mobile-select">Замовлення&nbsp;#178623</a>
                                <div className="on-mobile">02.03.2023</div>
                            </td>
                            <td className="no-mobile">
                                <ul className="list_purchaches">
                                    <li>
                                        <a href="/product?id=128384">Apple iPhone 5s 16GB Gold Neverlock (57726)</a>
                                    </li>
                                    <li>
                                        <a href="/product?id=35491">Кабель USB Lightning Комплектний </a>
                                    </li>
                                    <li>
                                        <a href="/product?id=34470">Блок живлення для iPhone Комплектний </a>
                                    </li>
                                </ul>
                            </td>

                            <td>
                                <div className="product_store">YNL Beresteika</div>
                            </td>
                            <td className="text-right" style={{ padding: '0.5rem .75rem' }}>
                                <a href="print?orders=178623" target="_blank"><h3><i className="bi bi-printer"></i></h3></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Shipments;